import {useState, useEffect} from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {Input} from '../../../components/forms/inputs'
import {isInvalidJSON} from '../../../components/forms/validators'
import type {ModelStageProps} from './types'

const EndpointHeaders = ({endpoint, onEndpointUpdate, setNextHandler, index}: ModelStageProps) => {
  const [validate, setValidate] = useState(false)
  const [headers, setHeaders] = useState(endpoint?.headers)

  const validator = isInvalidJSON
  useEffect(() => {
    const checkCorrect = () => {
      const valid = !validator(headers)
      setValidate(!valid)
      return valid
    }
    setNextHandler(checkCorrect)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, headers])

  return (
    <Box>
      <Typography>
        Here you can provide any headers that should be added to the request. They should be
        formatted as valid JSON.
      </Typography>

      <Input
        label="Endpoint Headers"
        value={headers || ''}
        validate={validate}
        validator={validator}
        setter={(val: string) => {
          setHeaders(val)
          onEndpointUpdate('headers', val)
        }}
        sx={{mt: 5, width: '100%'}}
      />
    </Box>
  )
}

export default EndpointHeaders
